import RemindSiteContentModal from './RemindSiteContentModal';

export default RemindSiteContentModal;
